import { FC } from "react";
import "./CalendarStyles.css"; // Import the CSS file

interface CalendarStylesProps {
  className?: string;
}

const CalendarStyles: FC<CalendarStylesProps> = ({ className }) => {
  return <div className={className} />;
};

export default CalendarStyles;
